import type { RootReduxState } from 'app/shared/flux/reducers';
import constants from 'app/shared/constants/ExperimentConstants';

const HALO_EXPERIMENT = constants.HOTPADS_WEB_HALO_MULTIVARIATE;
const TREATMENT_HALO_HDP_FEED = constants.HOTPADS_WEB_HALO_TREATMENT_HDP_FEED;

const getHaloTreatment = (state: RootReduxState): string | null => {
  const experiment = state.analytics.runningExperiments[HALO_EXPERIMENT];
  if (!experiment || experiment.isControl) return null;
  return experiment.treatment ?? null;
};

export const selectShowHaloFeed = (state: RootReduxState): boolean => {
  const treatment = getHaloTreatment(state);
  // haloHdp cookie override enables full experience for QA
  if (state.app.haloHdp) return true;
  return treatment === TREATMENT_HALO_HDP_FEED;
};

export const selectShowHaloShortlist = (state: RootReduxState): boolean => {
  return selectShowHaloFeed(state);
};

export const selectShowHaloViewModeToggle = (state: RootReduxState): boolean => {
  return selectShowHaloFeed(state);
};
